//import axios from "axios"
//import store from "@/store";

export default {
    // чтобы названия были локальные
    namespaced: true,

    state: {
        contract: null,
        payments: null,
        pastPayments: null,
    },
    getters: {
        contract(state){
            return state.contract
        },
        payments(state){
            return state.payments
        },
        pastPayments(state){
            return state.pastPayments
        },
        // всего платежей
        paymentsAllCount(state){
            if (state.payments){
                return state.payments.length
            }
            return 0
        },
        // сталось платежей
        paymentsRemaining(state){
            if (state.payments){
                let r = state.payments.filter(function(item) {
                    return item['PaymentСompleted'] == 0
                });
                return r.length
            }
            return 0
        },
        balanceNext(state){
            if (state.payments){
                let r = state.payments.filter(function(item) {
                    return item['PaymentСompleted'] == 1
                });
                return [ state.payments[r.length]['Balance'], state.payments[r.length+1]['Balance'] ]
            }
            return 0
        },
    },
    mutations: {
        setContractInfo(state, data){
            state.contract = data
        },
        setPayments(state, data){
            state.payments = data
        },
        setPastPayments(state, data){
            state.pastPayments = data
        },
        clearContractInfo(state){
            state.contract = null
        },
        clearPayments(state){
            state.payments = null
            state.pastPayments = null
        },
    },

}